module.exports = __webpack_public_path__ + "img/Cybersecurity.6225598e.png";